import {
  BellOutlined,
  CalendarOutlined,
  CheckCircleOutlined,
  CommentOutlined,
  EditOutlined,
  FileAddOutlined,
  PaperClipOutlined,
  PauseCircleOutlined,
  PlayCircleOutlined,
  RollbackOutlined,
  SafetyCertificateOutlined,
  SmileOutlined,
  StopOutlined,
  UserAddOutlined,
} from "@ant-design/icons";
import type React from "react";

interface NotificationTypeEntry {
  icon: React.ReactNode;
  color: string;
}

export const NOTIFICATION_TYPE_CONFIG: Record<string, NotificationTypeEntry> = {
  STANDBY: { icon: <PauseCircleOutlined />, color: "orange" },
  TASK_ADDED: { icon: <FileAddOutlined />, color: "blue" },
  FILE_UPLOADED: { icon: <PaperClipOutlined />, color: "blue" },
  TICKET_EDITED: { icon: <EditOutlined />, color: "default" },
  TICKET_ASSIGNED: { icon: <UserAddOutlined />, color: "purple" },
  TICKET_STARTED: { icon: <PlayCircleOutlined />, color: "green" },
  TICKET_FINISHED: { icon: <CheckCircleOutlined />, color: "success" },
  TICKET_APPROVED: { icon: <SafetyCertificateOutlined />, color: "success" },
  TICKET_REJECTED: { icon: <RollbackOutlined />, color: "orange" },
  TICKET_DELAYED: { icon: <StopOutlined />, color: "volcano" },
  TICKET_CONTINUED: { icon: <PlayCircleOutlined />, color: "green" },
  BOOKING_CREATED: { icon: <CalendarOutlined />, color: "purple" },
  BOOKING_CHANGED: { icon: <CalendarOutlined />, color: "blue" },
  BOOKING_CANCELLED: { icon: <CalendarOutlined />, color: "orange" },
  COMMENT_ADDED: { icon: <CommentOutlined />, color: "blue" },
  REACTION_ADDED: { icon: <SmileOutlined />, color: "orange" },
};

const FALLBACK_NOTIFICATION_TYPE: NotificationTypeEntry = {
  icon: <BellOutlined />,
  color: "default",
};

export function getNotificationTypeConfig(
  notificationType: string | undefined | null
): NotificationTypeEntry {
  if (!notificationType) return FALLBACK_NOTIFICATION_TYPE;
  return NOTIFICATION_TYPE_CONFIG[notificationType] ?? FALLBACK_NOTIFICATION_TYPE;
}

const ICON_COLORS: Record<string, { bg: string; fg: string }> = {
  orange: { bg: "rgba(250, 140, 22, 0.12)", fg: "#fa8c16" },
  blue: { bg: "rgba(24, 144, 255, 0.12)", fg: "#1677ff" },
  green: { bg: "rgba(0, 191, 165, 0.12)", fg: "#00bfa5" },
  purple: { bg: "rgba(114, 46, 209, 0.12)", fg: "#722ed1" },
  success: { bg: "rgba(82, 196, 26, 0.12)", fg: "#52c41a" },
  default: { bg: "rgba(99, 120, 137, 0.1)", fg: "#637889" },
};

export function resolveIconColors(color: string): { bg: string; fg: string } {
  return ICON_COLORS[color] ?? ICON_COLORS.default;
}
